<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M12 21q-1.86 0-3.5-.7a9 9 0 0 1-4.8-4.8A9 9 0 0 1 3 12q0-1.86.71-3.5a9.2 9.2 0 0 1 4.8-4.79A9 9 0 0 1 12 3q.21 0 .36.14t.14.36-.14.36T12 4Q8.68 4 6.34 6.34A7.7 7.7 0 0 0 4 12q0 3.33 2.34 5.66A7.7 7.7 0 0 0 12 20q3.33 0 5.66-2.34A7.7 7.7 0 0 0 20 12q0-.21.14-.36t.36-.14.36.14.14.36q0 1.85-.71 3.5a9 9 0 0 1-4.78 4.79q-1.65.7-3.52.71"
      />
    </svg>
  </span>
</template>
